module.exports = __webpack_public_path__ + "026ce455.svg";